import { Enrollment } from '@shared/common';
import React, { useState } from 'react';
import SessionModalSection, { ActionButton } from '../../DetailsModalSection';
import EnrollmentDetails, { EnrollmentDetailsType } from './EnrollmentDetails';
import EnrollmentDetailsForm from './EnrollmentDetailsForm';
import EnrollmentDetailsStatusForm from './EnrollmentDetailsStatusForm';

interface EnrollmentDetailsSectionProps {
  enrollment: Enrollment;
}

const EnrollmentDetailsSection = (props: EnrollmentDetailsSectionProps) => {
  const { enrollment } = props;

  const [isEdit, setIsEdit] = useState(false);
  const [isEditStatus, setIsEditStatus] = useState(false);

  const enrollmentDetails: EnrollmentDetailsType = {
    startDate: enrollment.startDate,
    endDate: enrollment.estimatedEndDate,
    lastStatus: enrollment?.lastStatus,
    noOfSessions: enrollment.noOfSessions,
    comment: enrollment.comment,
  };

  const buttons: ActionButton[] = [
    {
      buttonText: 'Edit',
      onClick: () => setIsEdit(true),
    },
    {
      buttonText: 'Change Status',
      onClick: () => setIsEditStatus(true),
    },
  ];

  return (
    <>
      {!isEdit && !isEditStatus && (
        <SessionModalSection sectionTitle={'Enrolment Details'} buttonsArray={buttons}>
          <EnrollmentDetails enrollmentDetails={enrollmentDetails} />
        </SessionModalSection>
      )}
      {isEdit && (
        <EnrollmentDetailsForm defaultData={enrollment} onCancel={() => setIsEdit(false)} />
      )}
      {isEditStatus && (
        <EnrollmentDetailsStatusForm
          defaultData={enrollment}
          onCancel={() => setIsEditStatus(false)}
        />
      )}
    </>
  );
};

export default EnrollmentDetailsSection;
